import type { ISpinnerProps } from '../../../interfaces/globals';

import './Spinner.scss';

const DEFAULT_SIZE = 16;

const Spinner = ({ size = DEFAULT_SIZE, variant = 'ring', color = 'default', className }: ISpinnerProps) => {
  const rootClass = ['spinner', `spinner--variant-${variant}`, `spinner--color-${color}`, className]
    .filter(Boolean)
    .join(' ');

  if (variant === 'svg') {
    return (
      <svg className={rootClass} width={size} height={size} viewBox="0 0 16 16" aria-hidden>
        <circle
          cx="8"
          cy="8"
          r="6"
          stroke="currentColor"
          strokeWidth="2"
          fill="none"
          strokeDasharray="28"
          strokeDashoffset="8"
          strokeLinecap="round"
        />
      </svg>
    );
  }

  return <span className={rootClass} style={{ width: size, height: size }} aria-hidden />;
};

export default Spinner;
